// Dedicated backend for the members' Golf Game Central GAME data (/ggGames,
// /memberGames, rosters, saved courses). Points at completetourneylive — the
// SAME backend the companion app (GolfGameCompanion) uses — so app and site
// share ONE source of truth, keyed to member ID, regardless of which project
// this site build's DEFAULT db (src/lib/firebase.js) targets.
//
// This is intentionally isolated: ONLY GGC game data lives here. Tournament,
// pro-shop, /club, and handicap-admin data stay on the build's default db.
import { initializeApp, getApps } from 'firebase/app'
import { getDatabase } from 'firebase/database'

// Public web config for completetourneylive (mirrors the companion app + CTL
// .env). Access is gated by RTDB rules + the memberAuth allowlist, not the key.
const ggConfig = {
  apiKey: 'AIzaSyBvw9vL3ibLZeKZN3e18Cr2oCgxCpEZ_p8',
  authDomain: 'completetourneylive.firebaseapp.com',
  projectId: 'completetourneylive',
  storageBucket: 'completetourneylive.firebasestorage.app',
  messagingSenderId: '323912066278',
  appId: '1:323912066278:web:50d1ff498a4eec1c088727',
  databaseURL: 'https://completetourneylive-default-rtdb.firebaseio.com',
}

const APP_NAME = 'ggBackend'
const ggApp = getApps().find((a) => a.name === APP_NAME) ?? initializeApp(ggConfig, APP_NAME)

// The RTDB handle the games layer uses. Imported as `db` by ggGamesData.js.
export const ggDb = getDatabase(ggApp)
